import { getRestraintsForModel, ItemRestraints } from "@core/shared/restraints";
import { FrontendAccessServiceProvider, FrontendExecutorProvider } from "./frontend-access-service-provider";
import * as i0 from "@angular/core";
import * as i1 from "./frontend-access-service-provider";
export class FrontendManualAccessServiceProvider {
  // AccessService cannot be auto-injected for unknown reasons.
  // likely the problem is introduced by the webpack module replacement.
  // use a provider with factory passing AccessService correctly.
  constructor(access) {
    this.access = access;
  }
  get() {
    return this.access;
  }
}
export let RestraintsFactory = /*#__PURE__*/(() => {
  class RestraintsFactory {
    constructor(acp, exp) {
      this.acp = acp;
      this.exp = exp;
    }
    create(ClassCtor) {
      return new ClassCtor(this.acp);
    }
    createForModel(ModelCtor) {
      const RestraintsCtor = getRestraintsForModel(ModelCtor);
      return new RestraintsCtor(this.acp, this.exp);
    }
    createDefault() {
      return new ItemRestraints(this.acp, this.exp);
    }
    static {
      this.ɵfac = function RestraintsFactory_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || RestraintsFactory)(i0.ɵɵinject(i1.FrontendAccessServiceProvider), i0.ɵɵinject(i1.FrontendExecutorProvider));
      };
    }
    static {
      this.ɵprov = /*@__PURE__*/i0.ɵɵdefineInjectable({
        token: RestraintsFactory,
        factory: RestraintsFactory.ɵfac,
        providedIn: 'root'
      });
    }
  }
  return RestraintsFactory;
})();